module.exports = __webpack_public_path__ + "static/media/paper3.5852d04a.png";